export default {
  /**
   * @description 将Date对象转换为字符串
   * @param {string} [dateDelimiter] 日期分隔符
   * @param {string} [timeDelimiter] 时间分隔符
   * @returns {String} 格式化后的日期
   */
  zzwToString: function (dateDelimiter = "-", timeDelimiter = ":") {
    const date = this;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
}



// WEBPACK FOOTER //
// ./src/utils/extensions/Date.js